export default "__VITE_ASSET__IdmngDU$__"